/**
 *
 * Asynchronously loads the component for InternalUser
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
